import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column w-100" }
const _hoisted_2 = {
  key: 0,
  class: "card col-12"
}
const _hoisted_3 = { class: "card-body pb-0" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_6 = { class: "symbol symbol-45px me-5" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = {
  href: "#",
  class: "text-gray-900 text-hover-primary fs-6 fw-bolder"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-2" }, null, -1)
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "d-flex justify-content-end align-items-center mb-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner-border me-2 spinner-border-sm",
  role: "status"
}
const _hoisted_15 = { class: "row mt-5 mt-xxl-8" }
const _hoisted_16 = { class: "card h-100" }
const _hoisted_17 = { class: "card-body px-5 py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteModal = _resolveComponent("DeleteModal")!
  const _component_Img = _resolveComponent("Img")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_NoteEditField = _resolveComponent("NoteEditField")!
  const _component_NoteViewField = _resolveComponent("NoteViewField")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteModal, {
      currentlySelectedEntry: 'note with id ' + _ctx.selectedNoteId,
      onDelete: _ctx.deleteNote
    }, null, 8, ["currentlySelectedEntry", "onDelete"]),
    _createElementVNode("div", _hoisted_1, [
      ((_ctx.$can('note_create', 'all') || _ctx.isCrewBoss(_ctx.job)) && _ctx.currentUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Img, {
                      src: _ctx.currentUser.photo_url
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.currentUser.name), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentUser.role, (role) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "text-gray-400 fw-bold",
                        key: role.id
                      }, _toDisplayString(role.title), 1))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode(_component_Form, {
                ref: "formComponent",
                class: "d-flex flex-column w-100",
                "validation-schema": _ctx.validationSchema,
                onSubmit: _ctx.saveNote
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Field, { name: "note" }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("textarea", _mergeProps({
                        class: "w-100 border-0 mt-5 mb-3",
                        rows: "3",
                        placeholder: "Write a note"
                      }, field, { name: "note" }), null, 16)
                    ]),
                    _: 1
                  }),
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "note" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      disabled: _ctx.saving,
                      class: "btn btn-sm btn-light-primary",
                      type: "submit"
                    }, [
                      (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.saving ? "Please wait" : "Add note"), 1)
                    ], 8, _hoisted_13)
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema", "onSubmit"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-12 pe-2 ps-2 pb-5",
            key: note.id
          }, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (_ctx.selectedNoteData !== null && _ctx.selectedNoteData.id == note.id)
                  ? (_openBlock(), _createBlock(_component_NoteEditField, {
                      key: 0,
                      comment: _ctx.selectedNoteData.text,
                      onDiscard: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedNoteData = null)),
                      onSave: _ctx.saveEditedNote
                    }, null, 8, ["comment", "onSave"]))
                  : (_openBlock(), _createBlock(_component_NoteViewField, {
                      key: 1,
                      note: note,
                      onOpenDeleteModal: _ctx.handleOpenDeleteModal,
                      onEdit: _ctx.handleEditNote
                    }, null, 8, ["note", "onOpenDeleteModal", "onEdit"]))
              ])
            ])), [
              [_directive_loading, _ctx.areGettingEdited.includes(note.id)]
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}